import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  AssetsAssetSchemaTypedWithId,
  AssetsAssetSchemaTypedWithIdNullable,
} from '@iconik-io/iconik-api/src/services/assets';

import { emptyUntilLoaded } from '../../../store/empty_slice_state';
import type { AssetPageAppState } from './types';

const initialState: AssetPageAppState = {
  asset: emptyUntilLoaded<AssetsAssetSchemaTypedWithId>(),
};

export const assetPageSlice = createSlice({
  name: 'asset',
  initialState,
  reducers: {
    setAsset: (
      state,
      action: PayloadAction<AssetsAssetSchemaTypedWithIdNullable>,
    ) => {
      state.asset = action.payload;
      state.assetId = action.payload.id;
    },
    assetClear: () => initialState,
  },
});

export const { setAsset, assetClear } = assetPageSlice.actions;

export const assetPageReducer = assetPageSlice.reducer;
